// Custom JavaScript
jQuery(document).ready(function($) {

	/**
	 * Search modal
	 */
	$('#wrapper-search').on('shown.bs.modal', function () {
		 $('#wrapper-search .search-form input[type=search]').focus();
	})  	
		
	
	var $scrolloffset = 110;		
	if ( Modernizr.mq('(max-width: 1024px)')) {
		$scrolloffset = 92;
	}
	if ( Modernizr.mq('(max-width: 768px)')) {
		$scrolloffset = 68;
	}
	
	
	/**
	 * Accordion
	 */
	// $('.answer.collapse').on('shown.bs.collapse', function() {
		
	// 	var $fixed_offset = 92;
	// 	if ( Modernizr.mq('(max-width: 1024px)')) {
	// 		$fixed_offset = 92;
	// 	}
	// 	if ( Modernizr.mq('(max-width: 768px)')) {
	// 		$fixed_offset = 68;
	// 	}
		
	// 	var $card = $(this).parent();
	// 	var $scroll_top = $card.offset().top - $fixed_offset;
	// 	$('html,body').animate({
	// 		scrollTop: $scroll_top
	// 	}, 500)
		
	// });	
	
	
	/**
	 * Pretty Dropdown
	 */
	
	if ( $('select').length > 0 ) {
		 var $dropdown = $('select').prettyDropdown({
			classic: true,
			height: 51,
			width: '100%'
		});	
	}
	
	
	/**
	 * Resources
	 */
	 
	// Functions 
	function hideElements() {
		$('.not-found').hide();
		$('.pagination-row').remove();		
		$('#posts-ajax .item').remove();
		$('.spinner-row').addClass('visible');
	}
	
	function loadAjax(href) {
		
		console.log( href );
		$('#posts-ajax').load(href + ' #posts-ajax>*', function(){
			$('.spinner-row.visible').remove();
		});		
		
	}
	
	function buildHref(thisObj) {
		
		var url = [location.protocol, '//', location.host, location.pathname].join('');	 
		var href = url + '?';		  
		var queryParams = new URLSearchParams(window.location.search);
		
		// Taxonomy filters
		var taxonomies = thisObj.data('taxonomies');
		$.each( taxonomies, function(index, element) {
			var filter = $('#select-' + element ).val();
			if ( filter ) {
				href = href + element + '=' + filter + '&';		
				queryParams.set( element, filter);
			} else {
				queryParams.delete( element );	
			}
		});
		
		// Search query
		var post_type = thisObj.data('post_type');		
		var search_query = encodeURIComponent($('#' + post_type + '-search-query').val());		
		if ( search_query != 'undefined' ) {
			href = href + 'search=' + search_query;		    
			queryParams.set('search', search_query);
		} else {
			queryParams.delete('search');	
		}
		
		// Update querystrings
		history.pushState(null, null, '?'+queryParams.toString());		
		
		return href;
	}
	 
	// AJAX pagination 
	$('#posts-ajax').on('click', '#pagination-ajax', function(e){
		
		e.preventDefault();
		$('.pagination-row').remove();
		$('.spinner-row').addClass('visible');
		
		var existinghtml = $('#posts-ajax').html();
		$('#posts-ajax').load($(this).attr('href') + ' #posts-ajax>*', function(){
			$('#posts-ajax').prepend(existinghtml);
			$('.spinner-row.visible').remove();
		});
		
	}); 	
	
	// Filters
	$(document).on('change', '.filter select', function() {
			
		hideElements();				
		if ( $(this).hasClass( 'cleared' )) {
			// "Clear filters" forces a "change" state for Pretty Dropdown. 
			// Prevent unnecessary AJAX reloads with the "cleared" class.
			$(this).removeClass( 'cleared' );
		} else {	
			var href = buildHref( $(this) );
			loadAjax(href);
		}
	
	});
	
	// Search
	$('.filters .filters-search-form').submit(function( event ) {
		event.preventDefault();	
	
		hideElements();		
		
		href = buildHref( $(this) );
		loadAjax(href);
	});		
	
	// Clear filters
	$('.clear-filters').click(function() {
	
		hideElements();
		
		var post_type = $(this).data('post_type');
		var search_placeholder = $(this).data('search_placeholder');		
				
		var url = [location.protocol, '//', location.host, location.pathname].join('');	 
		var href = url;
		var queryParams = new URLSearchParams(window.location.search);		    		    		
		
		var taxonomies = $(this).data('taxonomies');
		$.each( taxonomies, function(index, element) {
			queryParams.delete( element );	
		});
		queryParams.delete( 'search' );			
		//history.pushState(null, null, '');
		history.pushState(null, null, '?'+queryParams.toString());
	
		$('.filter select').val('').attr('selected','selected').addClass('cleared').change();
		$dropdown.refresh();
		
		$('#' + post_type + '-search-query').val('').attr('placeholder', search_placeholder );					
		
		loadAjax(href);
	});
	
	
	// var $container = $('.masonry-grid');	
	// $container.imagesLoaded( function() {
	// 	
	// 	$container.masonry({
	// 		itemSelector: '.masonry-grid-item',
	// 		gutter: 10
	// 	});
	// 	
	// });

	// Make Card Headings the same height
	if ( Modernizr.mq('(min-width: 768px)')) {
		$('.block.cards:not(.bg-white) .column h3').matchHeight();	
	}

	// Check if the user has scrolled to the bottom of an element
	function hasScrolledToBottom(element) {
    // Calculate the current scroll position
    const scrollTop = element.scrollTop;
    // Calculate the visible height of the element
    const visibleHeight = element.clientHeight;
    // Calculate the total scrollable height of the element
    const totalHeight = element.scrollHeight;

		// console.log( 'scrollTop: ' + scrollTop );
		// console.log( 'visibleHeight: ' + visibleHeight );
		// console.log( 'totalHeight: ' + totalHeight );

    // Check if the user has scrolled to within 100 pixels of bottom
    if (scrollTop + visibleHeight >= (totalHeight-100)) {
        return true; // User has scrolled to the bottom
    } else {
        return false; // User has not scrolled to the bottom
    }
	}

	// Force users to scroll to the bottom of the Terms and Conditions
	if( $(".scrollable-text").length > 0 ) {
		document.querySelector(".scrollable-text").addEventListener("scroll", function() {

			console.log( 'Edge testing 3');
				if (hasScrolledToBottom(this)) {
					$('.read-terms').removeClass('disabled');
					$('.read-terms input[type=checkbox]').removeAttr('disabled');
				} else {
					// console.log('not at bottom');
				}
		});
	}

	// When user clicks the checkbox, enable the submit button
	$('.read-terms input[type=checkbox]').click(function() {
		if ($(this).is(':checked')) {
			$('.frm_button_submit.frm_final_submit').removeAttr('disabled');
		} else {
			$('.frm_button_submit.frm_final_submit').attr('disabled', 'disabled');
		}
	});

	
	if ( $('body').hasClass('single-resource')) {

		// the input field
		var $input = $("input#on-page-search"),
		// clear button
		$clearBtn = $("button[data-search='clear']"),
		// prev button
		$prevBtn = $("button[data-search='prev']"),
		// next button
		$nextBtn = $("button[data-search='next']"),
		// the context where to search
		$content = $(".blocks"),
		// jQuery object to save <mark> elements
		$results,
		// the class that will be appended to the current
		// focused element
		currentClass = "current",
		// top offset for the jump (the search bar)
		offsetTop = 50,
		// the current index of the focused element
		currentIndex = 0;

		/**
		 * Jumps to the element matching the currentIndex
		 */
		function jumpTo() {
			if ($results.length) {
				var position,
					$current = $results.eq(currentIndex);
				$results.removeClass(currentClass);
				
				if ($current.length) {
					$current.addClass(currentClass);
					position = $current.offset().top - offsetTop;
					window.scrollTo(0, position);
				}
			}
		}

		/**
		 * Searches for the entered keyword in the
		 * specified context on input
		 */
		$input.on("input", function() {
			// Show all collapsed Boostrap 5 accordions
			$('.answer.collapse').each(function() {
				if (!$(this).hasClass('show')) {
					$(this).collapse('show');
				}
			});
			
			var searchVal = this.value;
			$content.unmark({
				done: function() {
					$content.mark(searchVal, {
						separateWordSearch: true,
						done: function() {
							$('.count-results').addClass('active');
							$results = $content.find("mark");

							if ( $results.length > 0 ) {
								$('#current-results').text( '1' );
							} else {
								$('#current-results').text( '0' );
							}

							$('#total-results').text( $results.length );
							currentIndex = 0;

							// Only start scrolling after 2 characters
							if ( searchVal.length > 2 ) {
								jumpTo();
							}
						}
					});
				}
			});
		});

		/**
		 * Clears the search
		 */
		$clearBtn.on("click", function() {
			$content.unmark();
			$('.count-results').removeClass('active');
			$input.val("").focus();
		});

		/**
		 * Next and previous search jump to
		 */
		$nextBtn.add($prevBtn).on("click", function() {
			if ($results.length) {
				currentIndex += $(this).is($prevBtn) ? -1 : 1;
				if (currentIndex < 0) {
					currentIndex = $results.length - 1;
				}
				if (currentIndex > $results.length - 1) {
					currentIndex = 0;
				}

				$('#current-results').text( currentIndex + 1 );
				jumpTo();
			}
		});

	};
		
});


jQuery(function($) {
	$(window).on('resize', function() {	  

		// Make Card Headings the same height
		if ( Modernizr.mq('(min-width: 768px)')) {
			$('.block.cards:not(.bg-white) .column h3').matchHeight();	
		}
		
	}).trigger('resize');
});


window.addEventListener("beforeunload", function () {
	// document.body.classList.add("animate-out");
});